import { Component, signal, ChangeDetectionStrategy, inject, OnInit } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { Header } from './core/components/header/header';
import { LoadingOverlayComponent } from './core/components/loading-overlay/loading-overlay.component';
import { InactivityService } from './core/services/inactivity.service';
import { ThemeService } from './core/services/theme.service';
import { filter } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-root',
  imports: [RouterOutlet, Header, LoadingOverlayComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected readonly title = signal('staff-journey-planner');
  
  private readonly _inactivityService = inject(InactivityService);
  private readonly _router = inject(Router);
  private readonly _themeService = inject(ThemeService);

  protected readonly isLoginRoute = toSignal(
    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map((event: any) => event.urlAfterRedirects.includes('/login'))
    ),
    { initialValue: true }
  );

  constructor() {
    this._themeService.initialize();
  }

  ngOnInit(): void {
    // Start tracking user activity globally across the app
    this._inactivityService.startTracking();
  }
}
